'use strict';
import gsap from 'gsap';

const $ = window.jQuery;

export default function() {
    $( '.incr-number' ).each( function() {
        gsap.to( this, {
            scrollTrigger: {
                trigger: this,
                onEnter: () => {
                    let $this = $( this );
                    let countTo = $this.attr( 'data-count' );

                    $( {
                        countNum: $this.attr( 'data-init' ),
                    } ).animate( {
                        countNum: countTo,
                    }, {
                        duration: 1500,
                        easing: 'swing',
                        step: function() {
                            $this.text( Math.floor( this.countNum ) );
                        },
                        complete: function() {
                            $this.text( ( this.countNum ).toLocaleString() );
                        },
                    } );
                },
            },
        } );
    } );
};
